<template>
  <div class="companyInformationView-all-box clearfix roleListAddMain">
    <card>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        class="demo-ruleForm clearfix"
        label-position="left"
      >
        <el-form-item prop="roleName">
          <div class="title-name">{{ $t('queryForm.roleName') }}<span>*</span></div>
          <el-input v-model="ruleForm.roleName" :placeholder="$t('queryForm.pleaseEnter')" :disabled="isdis == 1" />
        </el-form-item>

        <el-form-item prop="nameEn">
          <div class="title-name">{{ $t('formData.nameEn') }}<span>*</span></div>
          <el-input v-model="ruleForm.nameEn" :placeholder="$t('queryForm.pleaseEnter')" :disabled="isdis == 1" />
        </el-form-item>

        <el-form-item prop="roleStatus">
          <div class="title-name">{{ $t('administration.roleStatus') }}<span>*</span></div>
          <el-select v-model="ruleForm.roleStatus" :placeholder="$t('queryForm.pleaseSelect')" :disabled="isdis == 1">
            <el-option :label="$t('queryForm.enable')" value="1" />
            <el-option :label="$t('queryForm.disable')" value="0" />
          </el-select>
        </el-form-item>

        <el-form-item prop="roleDescription">
          <div class="title-name">{{ $t('administration.roleDescription') }}</div>
          <el-input v-model="ruleForm.roleDescription" :placeholder="$t('queryForm.pleaseEnter')" :disabled="isdis == 1" />
        </el-form-item>

        <el-form-item prop="roleType">
          <div class="title-name">{{ $t('administration.roleType') }}<span>*</span></div>
          <el-select v-model="ruleForm.roleType" :placeholder="$t('queryForm.pleaseSelect')" :disabled="isdis == 1">
            <el-option :label="$t('administration.Superadministrator')" value="0" />
            <el-option :label="$t('administration.system')" value="1" />
            <el-option :label="$t('administration.company')" value="2" />
            <el-option :label="$t('administration.project')" value="3" />
            <el-option :label="$t('administration.patent')" value="4" />
          </el-select>
        </el-form-item>

        <el-form-item class="line btn-box input-form-btn-list">
          <cus-btn type="cancel" @click="cancel()"></cus-btn>
          <cus-btn type="save" v-if="isdis !== 1" @click="submissionBtn('ruleForm')"></cus-btn>
        </el-form-item>
      </el-form>
    </card>
  </div>
</template>

<script>
import { roleSave, roleUpdate, roleDetail } from '../../api/adminManagement'
export default {
  name: 'CompanyInformationView',
  components: {},
  data() {
    return {
      ruleForm: {
        fileList: [],
        roleName: '',
        roleStatus: '1',
        roleDescription: '',
        nameEn: '',
        roleType: ''
      },
      // rules: {
      //   roleName: [{ required: true, message: '请输入', trigger: 'change' }],
      //   roleStatus: [{ required: true, message: '请输入', trigger: 'change' }],
      //   roleDescription: [{ required: true, message: '请输入', trigger: 'change' }]

      // },
      isdis: ''
    }
  },
  computed: {
    lang() {
      return this.$store.state.app.language
    },
    rules(){
      return {
        roleName: [{ required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'blur' }],
        roleStatus: [{ required: true, message: this.$t('queryForm.pleaseSelect'), trigger: 'change' }],
        // roleDescription: [{ required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'blur' }],
        nameEn: [{ required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'blur' }],
        roleType: [{ required: true, message: this.$t('queryForm.pleaseSelect'), trigger: 'change' }]
      }
    }
  },
  watch: {
    lang() {
    }
  },
  mounted() {
    // const self = this
    // window.companyInformationView = self

    if (this.$route.params.id) {
      this.isdis = this.$route.params.type
      this.subUserdetail()
    }
  },
  methods: {
    handleChange(file, fileList) {
      this.ruleForm.fileList = fileList.slice(-3)
    },

    /**
     * 返回上一页
     */
    cancel() {
      this.$router.push({
        name: 'roleList'
      })
    },

    // 账号提交
    submissionBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const self = this
          let param
          if (this.isdis == 2) {
            //  修改
            param = {
              name: self.ruleForm.roleName,
              description: self.ruleForm.roleDescription,
              status: self.ruleForm.roleStatus,
              id: self.$route.params.id, // id
              nameEn: self.ruleForm.nameEn,
              roleType: self.ruleForm.roleType//角色类型
            }
            roleUpdate(param)
              .then(response => {
                if (response.code === 200) {
                  this.$message({
                    message: response.message,
                    type: 'success'
                  })
                  this.$router.push({
                    name: 'roleList'
                  })
                }
              })
          } else {
            //  新增
            param = {
              name: self.ruleForm.roleName,
              description: self.ruleForm.roleDescription,
              status: self.ruleForm.roleStatus, 
              nameEn: self.ruleForm.nameEn,
              roleType: self.ruleForm.roleType//角色类型
            }
            roleSave(param)
              .then(response => {
                if (response.code === 200) {
                  this.$message({
                    message: response.message,
                    type: 'success'
                  })
                  this.$router.push({
                    name: 'roleList'
                  })
                }
              })
          }
        }
      })
    },

    // 查看
    subUserdetail() {
      const self = this
      const param = {
        id: self.$route.params.id // id
      }
      roleDetail(param)
        .then(response => {
          if (response.code === 200) {
            self.ruleForm.roleName = response.data.name
            self.ruleForm.roleStatus = response.data.status
            self.ruleForm.roleDescription = response.data.description
            self.ruleForm.nameEn = response.data.nameEn
            self.ruleForm.roleType = response.data.roleType//角色类型
          }
        })
    }

  }
}
</script>

<style scoped lang="scss">
.companyInformationView-all-box {
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  padding-top: 30px;
  margin-bottom: 90px;
}

</style>
<style lang="scss">
// .main-container{
// background: #fff;
// }
  .roleListAddMain{
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 90px;
      height: 90px;
      line-height: 90px;
      text-align: center;
    }
    .avatar {
      width: 90px;
      height: 90px;
      display: block;
    }
    .phoneImg{
      position: relative;
      .avatar-uploader{
        position: absolute;
      }
    }

  }

</style>
